<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="800px"
      scrollable
      @keydown="executeCloseModalCreateOrUpdateNameDocument"
      @click:outside="executeCloseModalCreateOrUpdateNameDocument"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>
            {{ currentNameDocument ? "Actualizar" : "Crear" }} Nombre de
            Documento
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-form @submit.prevent="sendUpdateOrCreateNameDocument">
              <v-row align-content="center" class="mt-2">
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label for="name">
                    <b> Nombre del Documento * </b>
                  </label>
                  <v-text-field
                    :placeholder="`Ingresa el Nombre del Documento`"
                    v-model="$v.form.name.$model"
                    :error="$v.form.name.$invalid && submitUpload"
                    :error-messages="
                      $v.form.name.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pt-0"
                  v-if="
                    !currentNameDocument &&
                      !isProject &&
                      !isPresale &&
                      activeBusinessUnits.length > 1
                  "
                >
                  <label class="mt-1">
                    <b> Unidad de Negocio * </b>
                  </label>
                  <v-autocomplete
                    placeholder="Selecciona la Unidad de Negocio"
                    @change="
                      getAssignedAreas({
                        business_unit_filter: form.business_unit.toUpperCase(),
                      });
                      form.responsible_area = null;
                    "
                    v-model="form.business_unit"
                    :items="activeBusinessUnits"
                    item-text="name"
                    item-value="code"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label class="mt-1">
                    <b> Área Responsable * </b>
                  </label>
                  <v-select
                    placeholder="Selecciona el Área Responsable"
                    v-model="form.responsible_area"
                    :disabled="!form.business_unit && !isProject && !isPresale"
                    :items="assignedAreas"
                    item-text="name"
                    item-value="id"
                    no-data-text="Sin Áreas Responsables"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pt-0"
                  v-if="!currentNameDocument"
                >
                  <label class="mt-1">
                    <b> Carpeta Contenedora * </b>
                  </label>
                  <h5 class="font-weight-bold">
                    {{
                      form.folder_id
                        ? form.folder_id.name
                        : "Sin Carpeta Seleccionada"
                    }}
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :disabled="
                            !form.business_unit && !isProject && !isPresale
                          "
                          @click="openModalSelectionFolderContainer()"
                          icon
                          color="success"
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                        >
                          <v-icon> mdi-folder-move </v-icon>
                        </v-btn>
                      </template>
                      <span
                        >{{ form.folder_id ? "Cambiar" : "Iniciar" }} Selección
                        de Carpeta Contenedora</span
                      >
                    </v-tooltip>
                  </h5>
                  <span
                    class="text-danger my-2"
                    v-if="$v.form.folder_id.$invalid && submitUpload"
                  >
                    <b>Debe seleccionar una Carpeta Contenedora</b>
                  </span>
                  <small
                    class="text-primary"
                    v-if="!form.business_unit && !isProject && !isPresale"
                  >
                    <b>IMPORTANTE: </b>
                    Selecciona la Unidad de Negocio para iniciar la selección de
                    Carpeta Contenedora
                  </small>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pb-0"
                  v-if="!currentNameDocument"
                >
                  <v-row align-content="center" class="mt-2">
                    <v-col cols="12" md="6" sm="12" class="pt-0">
                      <label class="mt-1">
                        <b> Obligatorio</b>
                      </label>
                      <v-checkbox
                        class="mt-0"
                        v-model="form.required"
                        :true-value="true"
                        :false-value="false"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="!isProject"
                    >
                      <label class="mt-1">
                        <b> Documento a Validar (Preventa)</b>
                      </label>
                      <v-checkbox
                        :disabled="!form.required"
                        class="mt-0"
                        v-model="form.pre_project_locked"
                        :true-value="true"
                        :false-value="false"
                      >
                      </v-checkbox>
                      <small class="text-primary mt-2">
                        <v-icon small color="warning"> mdi-alert </v-icon>
                        Solo se puede marcar esta opción si el documento esta
                        marcado como <b>Obligatorio</b>
                      </small>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  v-if="!currentNameDocument && !isProject && !isPresale"
                  cols="12"
                  md="6"
                  sm="12"
                  class="pt-0"
                >
                  <label class="mt-1">
                    <b> Documento de Cubicación</b>
                  </label>
                  <v-checkbox
                    class="mt-0"
                    v-model="form.is_cubicacion"
                    :true-value="true"
                    :false-value="false"
                  >
                  </v-checkbox>
                </v-col>
                <v-col
                  v-if="!currentNameDocument && !isProject && !isPresale"
                  cols="12"
                  md="6"
                  sm="12"
                  class="pt-0"
                >
                  <label class="mt-1">
                    <b> Documento con fecha validable</b>
                  </label>
                  <v-checkbox
                    class="mt-0"
                    v-model="form.is_date_validable"
                    :true-value="true"
                    :false-value="false"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalCreateOrUpdateNameDocument"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            @click="sendUpdateOrCreateNameDocument"
            :color="`${currentNameDocument ? 'warning' : 'primary'} text-white`"
            small
            class="float-right"
          >
            {{ currentNameDocument ? "Actualizar" : "Crear" }} Nombre de
            Documento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-selection-folder-container
      :modalAction="dialogSelectionFolderContainer"
      ref="modalSelectionFolderContainer"
      :closeModalSelectionFolderContainer="closeModalSelectionFolderContainer"
      @folderSelected="setFolderSelected"
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </modal-selection-folder-container>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import ModalSelectionFolderContainer from "../folders/ModalSelectionFolderContainer.vue";
import { filterDeletedFolders } from "@/helpers/document";
import { ACTIVE_BUSINESS_UNITS } from "@/constants/documents/maintainers";

export default {
  components: { ModalSelectionFolderContainer },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalCreateOrUpdateNameDocument: {
      type: Function,
      default: () => {},
    },
    currentNameDocument: {
      default: null,
    },
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadingFolders: false,
      dialogSelectionFolderContainer: false,
      debounce: null,
      debounceTime: 500,
      form: {
        name: null,
        responsible_area: null,
        folder_id: null,
        business_unit: null,
        required: false,
        pre_project_locked: false,
        is_cubicacion: false,
        is_date_validable: false,
      },
      submitUpload: false,
      responsibleAreas: [],
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        business_unit: {},
        responsible_area: { required },
        folder_id: this.currentNameDocument ? {} : { required },
        is_cubicacion: {},
        required: {},
        pre_project_locked: {},
      },
    };
  },
  methods: {
    ...mapActions({
      updateOrCreateNameDocument: "document/updateOrCreateNameDocument",
      associateNameDocument: "document/associateNameDocument",
      getAllfoldersDocuments: "document/getAllfoldersDocuments",
      getAssignedAreas: "document/getAssignedAreas",
      getDocumentsFolders: "document/getDocuments",
    }),
    setFolderSelected(folder) {
      this.form.folder_id = folder;
    },
    async sendUpdateOrCreateNameDocument() {
      let self = this;
      self.submitUpload = true;
      if (!self.$v.form.$invalid) {
        self.loading = true;
        let payload = {
          id: self.currentNameDocument
            ? self.currentNameDocument.document_type.id
            : undefined,
          name: self.form.name,
          assigned_area_id: self.form.responsible_area,
          business_unit_id: self.currentNameDocument
            ? self.currentNameDocument.folder.business_unit.id
            : self.isPresale || self.isProject
            ? self.currentPresale.business_unit.id
            : self.businessUnits.find(
                (item) => item.code == self.form.business_unit
              ).id,
          status: self.form.required ? true : false,
          created_by: self.user.email,
          updated_by: self.currentNameDocument ? self.user.email : undefined,
        };
        const resp = await self.updateOrCreateNameDocument(payload);
        if (resp.status == 200) {
          if (!self.currentNameDocument) {
            await self.associateNameDocument({
              folder_id: self.form.folder_id.id,
              document_type_id: resp.data.id,
              required: self.form.required ? true : false,
              is_cubicacion: self.form.is_cubicacion ? true : false,
              is_date_validable: self.form.is_date_validable ? true : false,
              created_by: self.user.email,
              pre_project_locked: self.form.pre_project_locked ? true : false,
            });
          }
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: self.currentNameDocument
              ? `Nombre de Documento actualizado correctamente`
              : `Nombre de Documento creado correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.loading = false;
          this.$emit("nameDocumentCreatedOrUpdated");
          this.closeModalCreateOrUpdateNameDocument(true);
          this.resetForm();
          return;
        }
        if (!resp.status || resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalCreateOrUpdateNameDocument($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalCreateOrUpdateNameDocument($event);
      }
    },
    async setNameDocument(nameDocument) {
      if (
        this.activeBusinessUnits.length > 1 &&
        !this.isPresale &&
        !this.isProject
      ) {
        await this.getAssignedAreas({
          business_unit_filter: nameDocument.folder.business_unit.code,
        });
      }
      this.form = {
        name: nameDocument.document_type.name,
        responsible_area:
          this.assignedAreas.find(
            (area) => area.name == nameDocument.document_type.assigned_area.name
          )?.id || null,
        business_unit: nameDocument.folder.business_unit.id,
      };
    },
    resetForm() {
      this.form = {
        name: null,
        business_unit: null,
        responsible_area: null,
        folder_id: null,
        required: false,
        is_cubicacion: false,
        is_date_validable: false,
      };
      this.submitUpload = false;
    },
    async openModalSelectionFolderContainer() {
      this.dialogSelectionFolderContainer = true;
      let foldersTreeViewMaintainer = await this.getDocumentsFolders({
        business_unit_filter: this.currentNameDocument
          ? this.currentNameDocument.folder.business_unit.id
          : this.isPresale || this.isProject
          ? this.currentPresale.business_unit.name
          : this.businessUnits.find(
              (item) => item.code == this.form.business_unit
            ).name,
        project_code: this.isProject
          ? this.getCodeProjectFromParamsOrQuery
          : undefined,
        pre_project_code: this.isPresale
          ? this.$route.params.codePresale
          : undefined,
        not_committed: true,
      });
      this.$refs.modalSelectionFolderContainer.setFoldersToSelect(
        filterDeletedFolders(foldersTreeViewMaintainer),
        true
      );
    },
    closeModalSelectionFolderContainer() {
      this.currentNameDocument = null;
      this.dialogSelectionFolderContainer = false;
    },
    setBusinessUnitUser() {
      this.form.business_unit =
        this.activeBusinessUnits.length == 1
          ? this.activeBusinessUnits[0].code
          : null;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      businessUnits: "document/businessUnits",
      foldersDocumentsFromBusinessUnit:
        "document/foldersDocumentsFromBusinessUnit",
      assignedAreas: "document/assignedAreas",
      currentProject: "project/currentProject",
      currentPresale: "presale/presale",
    }),
    activeBusinessUnits() {
      return this.businessUnits.filter((item) =>
        ACTIVE_BUSINESS_UNITS.includes(item.name)
      );
    },
    getCodeProjectFromParamsOrQuery(){
      return this.$route.params.codigoProyecto || this.$route.query.code  
    }
  },
  watch: {
    currentNameDocument(newForm) {
      if (newForm) {
        this.setNameDocument(newForm);
      } else {
        this.resetForm();
      }
    },
    "form.required": function(newValue) {
      if (!newValue) {
        this.form.pre_project_locked = false;
      }
    },
  },
};
</script>

<style></style>